import { KeyValue } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ICON, ICON_STYLE } from '@core/util/icon';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UrlService } from 'src/app/shared/services/url/url.service';
import { Link, NavigationSections, ProfileSelector } from './profile.selector';
import { Select } from '@ngxs/store';
import { TestHooks } from './profile.hooks';

/**
 * Child routes render components in the router-outlet:
 * - app-business-document-formatting (Formatting settings)
 */
@Component({
	selector: 'app-profile',
	templateUrl: './profile.component.html',
	styleUrls: ['./profile.component.scss'],
	standalone: false,
})
export class ProfileComponent implements OnInit {
	testHooks = TestHooks;
	detailsUrl = UrlService.Profile();
	ICON = ICON;
	integrationsUrl = UrlService.Profile_Integrations();
	showPassword$!: Observable<boolean>;

	@Select(ProfileSelector.getNavigation)
	navigation$: Observable<NavigationSections>;

	ICON_STYLE = ICON_STYLE;
	dashboardUrl = UrlService.Dashboard();

	constructor(private auth: AngularFireAuth) {}

	ngOnInit(): void {
		this.showPassword$ = from(this.auth.currentUser).pipe(
			map(
				(currentUser) =>
					!!currentUser.providerData.find(
						(provider) => provider.providerId === 'password',
					),
			),
		);
	}

	orderBy(a: KeyValue<number, Link>, b: KeyValue<number, Link>) {
		return a.value.order - b.value.order;
	}
}
